abstract class BaseDTO {
    id: string;

    constructor() {
        this.id = "";
    }

    toString(): string {
        return this.id;
    }

    shallowCopy(): BaseDTO {
        const copy = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
        return copy;
    }

    equals(obj: any): boolean {
        if (this === obj) return true;
        if (obj == null || !(obj instanceof BaseDTO)) return false;
        return this.id === obj.id;
    }

    getHashCode(): number {
        // A simple hash function for the GUID string
        let hash = 0;
        for (let i = 0; i < this.id.length; i++) {
            const char = this.id.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
}

export default BaseDTO;
